import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';

import { NavBar } from '../../components';
import { pinsRoute } from "../../routes/pinsRoute";

const Pins = ({ user }) => {
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <div className="px-2 md:px-5">
            <div className="bg-gray-50">
                <NavBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} user={user && user} />
            </div>
            <div className="h-full">
                <Routes>
                    {
                        pinsRoute.map(({name, path, Component}) => (
                            <Route key={name}
                                   path={path}
                                   element={<Component user={user && user}
                                                       searchTerm={searchTerm}
                                                       setSearchTerm={setSearchTerm}
                                   />}
                            />
                        ))
                    }
                </Routes>
            </div>
        </div>
    );
};

export default Pins;
